//Home.tsx
import { useEffect } from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
// import ContentCard from "../components/Home/ContentCard";
// import AddRequestCard from "../components/AddRequestCard";
import SearchCard from "../components/Home/SearchCard";
// import { ReactComponent as Hands } from "../images/hands.svg";
import { AnalyticsAction, logEvent, logPageView } from "../utils/analytics";
// import CrisisAlert from "../components/Home/CrisisAlert/CrisisAlert";
// import PeopleGridMobilePath from "../images/people_grid_mobile.png";
// import PeopleGridDesktopPath from "../images/people_grid_desktop.png";
import HousePin from "../images/house-pin.svg";
import PathwaysIcon from "../images/pathways-icon.svg"
//import SheildSliders from "../images/shield-sliders.svg";
import Handshake from "../images/handshake.svg";
// import { Link } from "react-router-dom";
import { handlePageLoad } from "../utils/accessibility";
import { Accordion } from "@trussworks/react-uswds";
import { AccordionItemProps } from "@trussworks/react-uswds/lib/components/Accordion/Accordion";
import { t } from "i18next";
import ReactMarkdown from "react-markdown";

const providerPortalUrl = process.env.REACT_APP_PROVIDER_PORTAL_URL ?? "";


const Wrapper = styled.div`
  background-color: rgba(0, 0, 0, 0);
`;

const StyledAccordionUpdateContent = styled.div`
  display:inline;
  overflow-wrap:normal;
  font-family:'Comfortaa';
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
  background: transparent;
  background-color: #c8bddc;
`;

function replaceSpans(text: string, css: string) {
  let parts = text.split("<<span>>");

  return parts.map((val: string, i: number) => i % 2 === 0 ? val : <span className={css}>{val}</span>);
}

type HomeProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

function Home({ isOpen, setIsOpen }: HomeProps) {
  const { t } = useTranslation();

  useEffect(() => {
    logPageView();
    handlePageLoad({ title: t("title"), noFocusH1: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function contactUsClick() {
    setIsOpen(true);
  }

  function getAccordionItem(itemKey: string): AccordionItemProps {
    return {
      title: <span className={"nice_font dark_blue"} style={{"fontFamily":"Comfortaa !important"}} >{`${t(`${itemKey}Question`)}`}</span>,
      expanded: false,
      className: "hp_faqAccordion",
      id: itemKey,
      content: (
        <div className={"divAccordion body_font dark_blue"} key={itemKey} >
          {itemKey === "toolkit" ? (
            <>
              <span className={"body_font dark_blue"}>{`${t("answerAbbreviation")}. ${t("toolkitAnswer")}`}</span>
              <ul>
                <li className={"body_font dark_blue"}>
                  {t("toolkitAnswerDownloadFAQ")}{" "}
                  {/* For whatever reason using react-router <Link> makes these only function as page redirects,
                      not content downloads even with 'download' attribute, so use vanilla <a> instead */}
                  <a download href="/resources/BHA OwnPath FAQs (EN).pdf" className={"body_font dark_blue"}>
                    {t("languageValuesEnglish").split("/")[0].trim()}
                  </a>
                  ,{" "}
                  <a download href="/resources/BHA OwnPath FAQs (ES).pdf" className={"body_font dark_blue"}>
                    {t("languageValuesSpanish").split("/")[0].trim()}
                  </a>
                </li>
                <li className={"body_font dark_blue"}>
                  {t("toolkitAnswerDownloadOnePager")}{" "}
                  <a download href="/resources/BHA OwnPath one pager (EN).pdf" className={"body_font dark_blue"}>
                    {t("languageValuesEnglish").split("/")[0].trim()}
                  </a>
                  ,{" "}
                  <a download href="/resources/BHA OwnPath one pager (ES).pdf" className={"body_font dark_blue"}>
                    {t("languageValuesSpanish").split("/")[0].trim()}
                  </a>
                </li>
              </ul>
            </>
            ): itemKey === "updateInfo" ? (
              <StyledAccordionUpdateContent>
              <p className={"body_font dark_blue"}>{`${t("answerAbbreviation")}. ${t("updateInfoAnswer")}` }</p>
              <p className={"body_font dark_blue"}>{`${t("updateInfoSecondLine")}`} 
                <a onClick={() => logEvent(AnalyticsAction.FAQProviderUpdateReportMissing)} href={t("complaintFormUrl") ?? ""} target="_blank" className="usa-link--external" rel="noreferrer">{`${t("updateInfoSecondSubmit")}`}</a>
              </p>
              </StyledAccordionUpdateContent>
            
          ) : (
            <div className="markdown-container">
            <p>
              <Trans 
                i18nKey= {itemKey + 'Answer'}
                components={{ 
                  strong: <span style={{fontWeight: "900"}}></span>,
                  ph988: <a href="tel:988"></a>,
                  link988: <a href="https://988colorado.com"></a>,
                  linkForm: <a href="https://cobha.gov1.qualtrics.com/jfe/form/SV_268Pai7zgwntO3c?Q_Language=EN"></a>,
                  linkIMatter: <a href="https://imattercolorado.org/"></a>,
                  linkLift: <a href="https://liftthelabel.org/GetHelp/"></a>,
                  linkQuitemos: <a href="https://quitemoslaetiqueta.org/"></a>,
                  linkRecvy: <a href="http://RecoveryCardsProject.com/"></a>,
                  linkCRAFT: <a href="http://CRAFTColorado.org/"></a>,
                  linkTough: <a href="http://ToughasaMother.org/"></a>,
                  linkGet: <a href="https://bha.colorado.gov/help/get-help-mental-health-drugs-or-alcohol/"></a>,
                  lkOP: <a href="https://ownpath.co/"></a>,
                  bulletList: <ul></ul>,
                  orderedList: <ol></ol>,
                  pgph: <p></p>,
                  lkYo: <a href="https://YoImportoColorado.org"></a>,
                  lkSafty: <a href="https://drive.google.com/file/d/1NqOBy8J-wUARCxogVIPg5mc8dKcYNUjl/view"></a>,
                  li: <li></li>,
                  contactUs:<button 
                          type="button" 
                          style={{border: "0px ", padding: 0, color: "blue", backgroundColor: "transparent", textDecoration: "underline", cursor: "pointer"}}
                          onClick={contactUsClick}>
                        </button>
                }}
              />
            </p>
            </div>
          )}
        </div>
      ),
      headingLevel: "h2",
    };
  }

  return (
    <Wrapper as="div">
      <div className="heroSection">
        <div className="hero_header nice_font">
          <span className='h1-home'>
            {t("connectingYouToBehavioralHealthcare")}
          </span>
          <div className="padding-top-1 padding-bottom-5 nice_font">
            <SearchCard isOpen={isOpen} setIsOpen={setIsOpen}/>
          </div>
        </div>
      </div>
      <div className="howItWorks nice_font">
        <div className="info_box">
          <div style={{"width":"960px","textAlign":"center","lineHeight":"30px", paddingBottom: "10px", paddingTop: "10px" }}>
            {t("inACrisis1")} <a href="tel:988">988</a> {t("inACrisis2")} <a target="_blank" href={t("crisisLink")} rel="noreferrer">{t("learnMore")}</a>
          </div>
        </div>
        <div className="columns">
          <div className="HIW_title">
            <div className="title">{t("howItWorks")}</div>
            <div className="text">{replaceSpans(t("coloradoLiftsHelpsConnect"), "lime_green")}</div>
          </div>
          <div className="HIW_instructions">
            <div className="house_pin"><img src={HousePin} alt=""/><h4>1.</h4><span>{t("1EnterYourZipCode")}</span></div>
            <div className="pathways_icon"><img src={PathwaysIcon} alt=""/><h4>2.</h4>{t("2TalkToANavigator")}</div>
            <div className="handshake"><img src={Handshake} alt=""/><h4>3.</h4>{t("3GetConnectedToCare")}</div>
          </div>
        </div>
      </div>
      <div className="homeQuestions nice_font">
        <div className="title">{t("commonQuestions")}</div>
        <Accordion className="hp_accordion"
          style={{"marginLeft":"0px!important","fontFamily":"Comfortaa"}}
          items={[
            "whatIsColoradoLifts",
            "whoCanUseColoradoLifts",
            "isColoradoLiftsTheSameAsTheOwnPathCareDirectory"
          ].map(getAccordionItem)}
          bordered={false}
        />
        <a href="/about" className="FAQlink">{t("seeMoreFrequentlyAskedQuestions")}</a>
      </div>
      <div className="homeProviders nice_font">
        <div className="title">{t("forProviders")}</div>
        <ReactMarkdown>{t("areYouAMentalHealthOrSubstanceUseTreatmentProviderInColorado")}</ReactMarkdown>
        <ReactMarkdown>{t("ifYouHaveOtherQuestions")}</ReactMarkdown>
      </div>
    </Wrapper>
  );
}

export default Home;